import React from 'react';
import { useTheme } from '../hooks/useTheme';

interface CitadeloLogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'full' | 'icon' | 'text';
  theme?: 'light' | 'dark' | 'auto';
  className?: string;
}

export const CitadeloLogo: React.FC<CitadeloLogoProps> = ({ 
  size = 'medium', 
  variant = 'full',
  theme = 'auto',
  className = ''
}) => {
  const { isDarkMode } = useTheme();
  
  const sizeMap = {
    small: 123,
    medium: 180,
    large: 246
  };

  const width = sizeMap[size];
  
  // Determine which logo to use:
  // - 'light' theme prop = use light logo (for dark backgrounds)
  // - 'dark' theme prop = use dark logo (for light backgrounds)  
  // - 'auto' = based on app dark mode (dark mode = light logo, light mode = dark logo)
  const useLightLogo = theme === 'light' || (theme === 'auto' && isDarkMode);
  
  const logoSrc = useLightLogo
    ? '/Citadelo_light.svg' 
    : '/Citadelo_dark.svg';
  
  const aspectRatio = useLightLogo ? 180 / 32 : 123 / 23;
  const height = width / aspectRatio;

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center' }}>
      <img 
        src={logoSrc} 
        alt="Citadelo" 
        style={{ 
          width: `${width}px`, 
          height: `${height}px`,
          display: 'block'
        }} 
      />
    </div>
  );
};

export default CitadeloLogo;

